import Vue from 'vue';
import VueRouter from 'vue-router';
import ContractRouter from '@/views/contract/contract-router';
import BillingRouter from '@/views/billing/billing-router';
import AccessDeniedRouter from '@/views/access-denied/access-denied-router';
import OverviewRouter from '@/views/overview/overview-router';
import ConfigurationRouter from '@/views/configuration/configuration-router';
import InstancesRouter from '@/views/instances/instances-router';
import PaymentFileRouter from '@/views/payment-file/payment-file-router';
import ContractGroupRouter from '@/views/contract-group/contract-group-router';
import ErrorMonitorRouter from '@/views/error-monitor/error-monitor-router';
import AuthorityService from '@/domain/security/authority.service';
import BusinessUnitStore from '@/domain/business-unit/service/business-unit.store';
import menuItems from '@/shared/menu-header/menu-items.json';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...ContractRouter,
    ...AccessDeniedRouter,
    ...BillingRouter,
    ...OverviewRouter,
    ...ConfigurationRouter,
    ...InstancesRouter,
    ...PaymentFileRouter,
    ...ContractGroupRouter,
    ...ErrorMonitorRouter,
  ],
});

function findMenuItem(path: string) {
  return menuItems.find((item) => {
    if (!item.path) return false;
    const itemPath = (item.path as string).split('?')[0];
    if (itemPath === '/') return path === '/';
    return path === itemPath || path.startsWith(`${itemPath}/`);
  });
}

router.beforeEach(async (to, _from, next) => {
  if (to.path === '/access-denied') return next();

  const menuItem = findMenuItem(to.path);
  if (!menuItem) return next();

  if ((menuItem as any).enabled === false) return next('/access-denied');

  const authorities: string[] = (menuItem as any).authorities ?? [];
  const profiles: string[] = (menuItem as any).profiles ?? [];
  const hasAuthRestriction = authorities.length > 0;
  const hasProfileRestriction = profiles.length > 0;

  if (!hasAuthRestriction && !hasProfileRestriction) return next();

  const userAuthorities = await AuthorityService.authorities();
  const currentProfile: string = BusinessUnitStore.currentBusinessUnit?.profile || '';

  const authMatch = hasAuthRestriction && authorities.some((a) => userAuthorities.includes(a));
  const profileMatch = hasProfileRestriction && profiles.includes(currentProfile);

  if (authMatch || profileMatch) return next();
  return next('/access-denied');
});

export default router;
